export const FORM_FIELD_NAMES = {
    SUB_DOMAIN: "subDomain",
    RELATIVE: "relative",
    NAME: "name",
    LANGUAGE_CODE: "languageCode",
    PRODUCT: "product"
}